import { render, staticRenderFns } from "./VoiceCare.vue?vue&type=template&id=1588b73f&scoped=true"
import script from "./VoiceCare.vue?vue&type=script&lang=js"
export * from "./VoiceCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588b73f",
  null
  
)

export default component.exports